import { useList, useGetList, ListContextProvider } from 'react-admin'
import PropTypes from 'prop-types'
import ComponentWrapper from './ComponentWrapper'
import TableLayout from './TableLayout'

export default function LockedLeads({ userId }) {
  const { data, isPending } = useGetList('quote-requests', {
    pagination: { page: 1, perPage: 1000 },
    filter: { 'inUse.id': userId },
  })

  const listContext = useList({
    data,
    isPending,
    perPage: 10,
  })

  // Dont show section if data empty
  if (isPending || data === undefined || data.length === 0) {
    return <></>
  }

  return (
    <ComponentWrapper title={'Current leads you are locked in'}>
      <ListContextProvider value={listContext}>
        <TableLayout userId={userId} showUnlockButton={true} />
      </ListContextProvider>
    </ComponentWrapper>
  )
}

LockedLeads.propTypes = {
  userId: PropTypes.string,
}
